<template>
    <div class="alert alert-danger p-0 mb-0">
        <div class="d-flex align-items-center">
            <div class="flex-grow-1 fw-bold text-center">
                {{ message }}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            message: { type: String, required: false, default: null }
        }
    };
</script>
